<template>
  <v-dialog v-model="dialog" max-width="650">
    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-title>
          Editar produto
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <MoneyInput
            v-model="form.preco_venda"
            label="Preço devolução"
            filled
          />
          <v-text-field
            v-model="form.quantidade_produto"
            type="number"
            label="Quantidade"
            style="width: 120px"
            filled
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-list-item class="mx-2">
          <v-list-item-content>
            <v-list-item-title>
              Total
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            {{ formatMoney(total) }}
          </v-list-item-action>
        </v-list-item>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn type="submit" block color="primary">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import MoneyMixin from "@/mixins/MoneyMixin";
import MoneyInput from "@/components/MoneyInput";

export default {
  mixins: [MoneyMixin],
  components: { MoneyInput },

  data() {
    return {
      dialog: false,
      form: {},
      index: null
    };
  },

  methods: {
    init(product, index) {
      this.form = { ...product };
      this.index = index;
      this.dialog = true;
    },
    submit() {
      this.$emit("submit", this.form, this.index);
      this.dialog = false;
    }
  },

  computed: {
    total() {
      return this.form.quantidade_produto * this.form.preco_venda;
    }
  }
};
</script>
